module.exports = __webpack_public_path__ + "@/assets/img/03.96740951.svg";